import moment from "moment";
import react, {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import apiService from "./apiService";
import { TimeInformation } from "../interfaces/TimeInformation";

interface ClockContextProps {
  clockDiff: number;
  setDiff: (inp: string) => void;
  getMomentUTC: () => moment.Moment;
  getMomentUTCDiff: (diff:number) => moment.Moment;
  getMoment: () => moment.Moment;
  getMomentDiff: (diff:number) => moment.Moment;
  setRaceIDClock: (inp: number) => void;
}
const ClockContext = createContext<ClockContextProps | undefined>(undefined);

type ClockProviderref = { children: ReactNode };

export const ClockProvider: React.FC<ClockProviderref> = ({ children }) => {
  const [clockDiff, setClockDiff] = useState<number>(0);
  const [raceIDClcok, setRaceIDClock] = useState<number | null>(null);
  const diffref = useRef<number>(0);
  const raceIDref = useRef<number | null>(null);

  useEffect(() => {
    // console.log("Alfred");
    let interval = setInterval(() => {
      //console.log(moment().format("HH:mm:ss"));
      donwnloadServerTime();
    }, 30000);
    donwnloadServerTime();

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    raceIDref.current = raceIDClcok;
    donwnloadServerTime();
  }, [raceIDClcok]);
  const donwnloadServerTime = () => {
    if (raceIDref.current !== null) {
      //apiService.get(`Tools/GetRaceTime?RaceId=${raceIDref.current}`)
      const fetchData = async () => {
        // try {
        try {
          const result = await apiService.get<TimeInformation>(
            `api/Tools/GetRaceTime?RaceId=${raceIDref.current}&ApiKey=#apikey#`
          );
          setDiff(result.AdjustedTime);
          //   setRaceData(EvOP);
        } catch (error) {
          console.log(error);
        }
      };
      fetchData();
    }
  };
  const setDiff = (newTime: string) => {
    let dif = moment(newTime).utc().diff(moment().utc());
    if (Math.abs(dif - diffref.current) > 50) {
      diffref.current = dif;
      setClockDiff(dif);
      console.log("Diff from server:",dif,"MS");
    }
  };
  const getMomentUTC = (): moment.Moment => {
    // console.log(moment().utc().add(clockDiff));
    return moment().utc().add(clockDiff);
  };
  const getMoment = (): moment.Moment => {
    return moment().add(clockDiff);
  };
  const getMomentDiff = (diff:number): moment.Moment => {
    return moment().add(diff);
  };
  const getMomentUTCDiff = (diff:number): moment.Moment => {
    return moment().utc().add(diff);
  };
  return (
    <ClockContext.Provider
      value={{
        clockDiff,
        setDiff,
        getMomentUTC,
        getMoment,
        getMomentDiff,
        setRaceIDClock,
        getMomentUTCDiff
      }}
    >
      {children}
    </ClockContext.Provider>
  );
};

export const useClock = (): ClockContextProps => {
  const context = useContext(ClockContext);
  if (!context) {
    throw new Error("useClock must be used within a ClockProvider");
  }
  return context;
};
